import React, { FC, useState } from 'react';
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { DeviceLogData } from '../../api/mobilbase/models';
import * as mobilbase from '../../api/mobilbase';
import APIRequest from './APIRequest';
import DeviceLogTable from '../Table/DeviceLogTable';

interface DeviceLogDataFetcherProps {
  locationId: number;
  deviceId: number;
  deviceName?: string;
}

export const DeviceLogDataFetcher: FC<DeviceLogDataFetcherProps> = ({ locationId, deviceId }) => {
  const [logData, setLogData] = useState<DeviceLogData>({ deviceName: "", events: [] });
  const [isPending, setIsPending] = useState(false);
  const [run, setRun] = useState(true);

  const fetchDeviceLog = () => mobilbase.getDeviceLog({ locationId, deviceId });

  return (
    <Grid container spacing={2}>
      <APIRequest<DeviceLogData>
        run={run}
        setRun={setRun}
        pending={isPending}
        setIsPending={setIsPending}
        req={fetchDeviceLog}
        setData={setLogData}
      />
      <Grid item xs={12}>
        {/* <Typography component="h1" variant="h5">
          Hændelseslog - {deviceName || "INGEN VALGT"}
        </Typography> */}
        {isPending ? (
          <CircularProgress />
        ) : (
          <DeviceLogTable data={logData} isPending={isPending} setRun={setRun} />
        )}
      </Grid>
    </Grid>
  );
};

export default DeviceLogDataFetcher;